import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { FontColor, TextAlign, TextSize } from '@freelancer/ui/text';
import { HowItWorksViewType } from 'app/how-it-works-page/how-it-works-page.types';

@Component({
  selector: 'app-upsell',
  template: `
    <fl-container
      class="Upsell"
      [ngClass]="{ 'Upsell--center': alignment === TextAlign.CENTER }"
    >
      <fl-bit
        class="Upsell-wrapper"
        [class.Upsell-wrapper--center]="alignment === TextAlign.CENTER"
      >
        <fl-heading
          i18n="Upsell blade header"
          [color]="HeadingColor.LIGHT"
          [headingType]="HeadingType.H2"
          [size]="TextSize.XLARGE"
          [sizeDesktop]="TextSize.XXLARGE"
          [textAlign]="alignment"
          [flMarginBottom]="'mid'"
        >
          So what are you waiting for?
        </fl-heading>
        <fl-text
          [size]="TextSize.SMALL"
          [sizeTablet]="TextSize.MID"
          [sizeDesktop]="TextSize.LARGE"
          [color]="FontColor.LIGHT"
          [textAlign]="alignment"
          [flMarginBottom]="'large'"
          [flMarginBottomTablet]="'xlarge'"
        >
          <ng-container
            *ngIf="
              viewType === HowItWorksViewType.CLIENT;
              else freelancerViewDescription
            "
            i18n="Upsell description for employer view"
          >
            Post a project today and get bids from talented freelancers.
          </ng-container>
          <ng-template #freelancerViewDescription>
            <ng-container i18n="Upsell description for freelancer view">
              Search for the right job and write your best bid proposal now.
            </ng-container>
          </ng-template>
        </fl-text>
        <fl-button
          [flTrackingLabel]="
            viewType === HowItWorksViewType.CLIENT
              ? 'PostProjectButton'
              : 'BrowseJobsButton'
          "
          [link]="
            disableLink
              ? undefined
              : viewType === HowItWorksViewType.CLIENT
              ? '/post-project'
              : '/jobs'
          "
          [color]="ButtonColor.PRIMARY"
          [size]="ButtonSize.SMALL"
          [sizeTablet]="ButtonSize.LARGE"
          (click)="handlePostButtonClick()"
        >
          <ng-container
            *ngIf="
              viewType === HowItWorksViewType.CLIENT;
              else freelancerViewButton
            "
            i18n="Button text for posting a project"
          >
            Post a Project
          </ng-container>
          <ng-template #freelancerViewButton>
            <ng-container i18n="Button text for browsing jobs">
              Browse Jobs
            </ng-container>
          </ng-template>
        </fl-button>
      </fl-bit>
    </fl-container>
  `,
  styleUrls: ['./upsell.component.scss'],
})
export class UpsellComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  TextAlign = TextAlign;
  TextSize = TextSize;

  HowItWorksViewType = HowItWorksViewType;

  @Input() viewType = HowItWorksViewType.CLIENT;
  @Input() alignment = TextAlign.LEFT;
  @Input() disableLink = false;
  @Output() postButtonClicked = new EventEmitter<void>();

  handlePostButtonClick(): void {
    this.postButtonClicked.emit();
  }
}
